// extracted by mini-css-extract-plugin
export default {"navbar-sport-light":"NavBar_navbar-sport-light__ewmS9","navbar-logo":"NavBar_navbar-logo__z75Cx","navbar-text":"NavBar_navbar-text__ktUX9","app-name":"NavBar_app-name__0EdC9"};